<div class="body_wrapper">
    <section class="unauthorized-main">
      <div class="mini-container">
        <div class="unauthorized-content-wrap">
          <img src="../../../assets/img/unauthorized-img.png" alt="404" class="img-fluid">
          <h2>Error! Unauthorized</h2>
          <p>Your Not authorized to access this page.</p>
          <a class="unauthorized-btn" href="/login">Home page</a>
        </div>
      </div>
    </section>
  </div>